import { Equal }		from "ts-base/equal";
import { Group }		from "ts-base/group";
import { Comparator }	from "ts-base/comparator";

export namespace BigInts {
	export const equal:Equal<bigint>		= Equal.builtin;
	export const compare:Comparator<bigint>	= Comparator.builtin;

	export const sum:Group<bigint>	= {
		empty:			0n,
		concat:			(a, b)	=> a + b,
		inverse:		(a)		=> -a,
		concatInverse:	(a, b)	=> a - b,
	};

	export const product:Group<bigint>	= {
		empty:			1n,
		concat:			(a, b)	=> a * b,
		inverse:		(a)		=> 1n / a,
		concatInverse:	(a, b)	=> a / b,
	};
}
